import { render } from "./Footer.vue?vue&type=template&id=449540f8"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import exportComponent from "/home/ali/PhpstormProjects/insta-catalog-view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__